import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      gap: 20px;
      img {
        width: 66px !important;
        height: 66px;
        border-radius: 18px;
        object-fit: cover;
        flex: none;
      }
    `}
`;

export const ProfileInfo = styled.div`
  margin-left: 30px;
  color: #fff;
  font-size: 15px;
  flex-grow: 1;
  div {
    display: flex;
    align-items: center;
  }
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      margin-left: 0;
      color: var(--cp-text);
    `}
`;

export const Name = styled.p`
  font-size: 26px;
  margin-bottom: 15px;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      font-size: 22px;
      font-weight: 600;
      margin-bottom: 6px;
      color: var(--cp-text);
    `}
`;
export const Type = styled.p`
  font-size: 15px;
  margin-bottom: 15px;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      font-size: 13px;
      margin-bottom: 12px;
      color: var(--cp-text-secondary);
    `}
`;

export const AccountLink = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
`;

export const Right = styled.div`
  text-align: right;
`;

export const Amount = styled.p`
  font-size: 20px;
  margin-right: 30px;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      font-size: 18px;
      color: var(--cp-text);
    `}
`;
